const SendFormWrapper = require('../../modules/wrappers/SendFormWrapper');
const {getLanguage} = require('../layout/js/multilanguage');

window.addEventListener('load', () => {

    let storageData = localStorage.getItem('FormWrapperData');

    let original = null;

    let form = new SendFormWrapper();

    let editor = false;

    if (window.panel && window.panel.state.editor) editor = true;

    if (!editor) {
        document.getElementById('announcementForm').addEventListener('submit', e => {
            e.preventDefault();

            if (!form.isValid()) {
                form.validate();
                return;
            }

            let formData = new FormData();

            formData.append('form_model', JSON.stringify(form.model));

            fetch("/api/announcement", {method: "POST", body: formData})
                .then(res => res.json())
                .then(state => {
                    let lang = getLanguage();
                    localStorage.setItem('FormWrapperData', "");
                    location.href = `${lang}/announcement/${state.data.publicID}?accessCode=${state.data.accessCode}`;
                })
                .catch(err => console.log(0, err))
        });
    }

    form.addListener(() => {
        localStorage.setItem('FormWrapperData', JSON.stringify(form.model))
    });

});